import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-20">
        <div className="container mx-auto max-w-7xl px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms & Conditions</h1>
        </div>
      </section>

      {/* Terms Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
            <div className="prose max-w-none">
              <div className="bg-blue-50 border-l-4 border-blue-600 p-4 mb-6">
                <p className="text-sm text-slate-700 leading-relaxed">
                  <strong>Legal Notice:</strong> This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
                </p>
              </div>

              <p className="text-slate-700 mb-6 leading-relaxed">
                This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of domain name <strong>learnersedge.in</strong> including the related mobile site and mobile application (hereinafter referred to as 'Platform').
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Acceptance and Binding Agreement</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                Your use of the Platform and services and tools are governed by the following terms and conditions ("Terms of Use") as applicable to the Platform including the applicable policies which are incorporated herein by way of reference. If You transact on the Platform, You shall be subject to the policies that are applicable to the Platform for such transaction. By mere use of the Platform, You shall be contracting with the Platform Owner and these terms and conditions including the policies constitute Your binding obligations, with Platform Owner.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Scope of Services</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                These Terms of Use relate to your use of our website, goods (as applicable) or services (as applicable) (collectively, 'Services'). Any terms and conditions proposed by You which are in addition to or which conflict with these Terms of Use are expressly rejected by the Platform Owner and shall be of no force or effect.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Modifications to Terms</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                These Terms of Use can be modified at any time without assigning any reason. It is your responsibility to periodically review these Terms of Use to stay informed of updates. Your continued use of the Platform following the posting of changes will mean that you accept and agree to the changes.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Use License</h2>
              <p className="text-slate-700 mb-4 leading-relaxed">
                Permission is granted to temporarily access the materials (information or software) on the Platform for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc list-inside text-slate-700 mb-6 space-y-2">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to reverse engineer any software contained on the Platform</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Course Enrollment and Payment</h2>
              <p className="text-slate-700 mb-4 leading-relaxed">
                When you enroll in a course on the Platform:
              </p>
              <ul className="list-disc list-inside text-slate-700 mb-6 space-y-2">
                <li>Payment must be completed before accessing full course materials</li>
                <li>Course access is subject to admin approval as outlined in our enrollment policy</li>
                <li>All payments are processed securely through our payment gateway</li>
                <li>Refunds are subject to our refund policy and must be requested within 14 days of enrollment</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">User Accounts</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account. The Platform Owner reserves the right to terminate accounts, remove or edit content at its sole discretion.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Intellectual Property Rights</h2>
              <p className="text-slate-700 mb-4 leading-relaxed">
                All course materials including PDFs, videos, quizzes, and other content are protected by copyright and intellectual property laws and are for your personal use only. You may not:
              </p>
              <ul className="list-disc list-inside text-slate-700 mb-6 space-y-2">
                <li>Download, copy, or distribute course materials to third parties</li>
                <li>Screenshot or record protected course content</li>
                <li>Share your account credentials with others</li>
                <li>Use course materials for commercial purposes without written permission</li>
                <li>Reproduce, duplicate, copy, sell, resell or exploit any portion of the Platform</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Prohibited Activities</h2>
              <p className="text-slate-700 mb-4 leading-relaxed">
                You agree not to:
              </p>
              <ul className="list-disc list-inside text-slate-700 mb-6 space-y-2">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on the intellectual property rights of others</li>
                <li>Upload viruses or malicious code</li>
                <li>Spam, phish, pharm, pretext, spider, crawl, or scrape</li>
                <li>Interfere with or circumvent security features of the Platform</li>
                <li>Engage in any automated use of the system</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Disclaimer of Warranties</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                The materials on the Platform are provided on an 'as is' and 'as available' basis. The Platform Owner makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Limitation of Liability</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                In no event shall the Platform Owner or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on the Platform, even if the Platform Owner or an authorized representative has been notified orally or in writing of the possibility of such damage.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Indemnification</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                You agree to indemnify, defend and hold harmless the Platform Owner and its affiliates, officers, directors, employees, consultants, agents, and representatives from any and all third party claims, losses, liability, damages, and/or costs arising from your use of the Platform, your violation of these Terms of Use, or your infringement of any intellectual property or other right of any person or entity.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Governing Law and Jurisdiction</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                These Terms of Use shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these Terms of Use shall be subject to the exclusive jurisdiction of the courts located in India.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Severability</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                If any provision of these Terms of Use is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that these Terms of Use will otherwise remain in full force and effect and enforceable.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Contact Information</h2>
              <p className="text-slate-700 mb-2 leading-relaxed">
                If you have any questions about these Terms & Conditions, please contact us:
              </p>
              <ul className="list-none text-slate-700 mb-6 space-y-1">
                <li>Email: admin@learnersedge.in / learnersedge2.0@gmail.com</li>
                <li>Phone: +91 9219485048</li>
                <li>Address: Ghaziabad, UP India</li>
                <li>Website: learnersedge.in</li>
              </ul>

              <div className="bg-slate-100 p-4 rounded-lg mt-8">
                <p className="text-sm text-slate-600 italic">
                  These Terms of Use were last updated on January 2025. Please review these terms periodically for changes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Terms;
